<template>
  <div class="project-weather public-bg">
    <p class="weather-title">24小时预报</p>
    <div class="echart-line-bar">
      <div class="weather-icon" :class="bacImage"></div>
      <div class="weather-icon weather-cloudy" :class="bacImage5" ></div>
      <v-chart style="height:210px;width:3.8rem;" ref="lineEchart" :options="lineAndBarOption"></v-chart>
    </div> 
  </div>
</template>
<script>
import echarts from "echarts"; 
export default {
  name: "weatherLine",
  components: {},
  props: {
    lineFuture: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      echartfalse: false,
      bacImage: '',
      bacImage5: '',
      lineAndBarOption: {
        color: "#0E9CFF",
        tooltip: {
          // trigger: 'axis',
          show:false,
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            minorTick: {
              show: false
            },
            boundaryGap: false,
            data: []
          },
          {
            type: "category",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            minorTick: {
              show: false
            },
            axisLabel: {
              color: "#B7B7B7"
            },
            data: [],
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "温\n度",
            // min: 18,
            nameGap: -15,
            nameTextStyle: {
              color: "#FFFFFF",
              fontSize: 14,
              align: "left",
              padding: [0, 0, -20, -50]
            },
            interval: 30,
            splitLine: {
              show: false
            },
            axisLabel: {
              color: "#B7B7B7"
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          {
            type: "value",
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            name: "风\n力",
            nameGap: -15,
            nameTextStyle: {
              fontSize: 15,
              color: "#FFFFFF",
              padding: [0, 0, -20, -30],
              align: "left",
            },
            gridIndex: 1
          }
        ],
        grid: [
          {
            left: 70,
            right: 20,
            top: 30,
            bottom: "55%"
          },
          {
            left: 50,
            right: 20,
            top: "60%",
            bottom: 40
          }
        ],
        series: [
          {
            data:[],
            // data: [30, 28, 26, 24, 20, 22, 18, 19],
            type: "line",
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(0, 150, 240, 0.6)"
                },
                {
                  offset: 1,
                  color: "rgba(26, 30, 57, 0.6)"
                }
              ])
            },
            lineStyle: {
              color: "#0E9CFF",
            }, 
          },
          {
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            // data: [2, 4, 4, 5, 4, 5, 4, 4],
            type: "bar",
            barWidth: 10,
            color: "#0B79F0",
            label: {
              show: true,
              color: "#B7B7B7",
              position: "top"
            }
          }
        ]
      }
    };
  },
  mounted() {
    // console.log(this.lineFuture)

    // debugger
    if(this.lineFuture.length > 0){
      this.getTimeHours();
      this.getFutureWeather();
      this.timer = setTimeout(() => {
        this.getTimeHours();
        this.getFutureWeather();
      }, 1000 * 60 * 60 * 3);
      window.addEventListener("resize", this.resizeTheChart);
    }
  },
  watch: {
    lineFuture(val){
      // console.log(val)
      if(val){
        this.getTimeHours();
        this.getFutureWeather();
        this.timer = setTimeout(() => {
          this.getTimeHours();
          this.getFutureWeather();
        }, 1000 * 60 * 60 * 3);
        window.addEventListener("resize", this.resizeTheChart);
      }
      // console.log(old)
    }
  },
  methods: {
    resizeTheChart() {
      if (this.$refs && this.$refs.lineEchart) {
        this.$refs.lineEchart.resize();
      }
      if (this.$refs && this.$refs.barEchart) {
        this.$refs.barEchart.resize();
      }
    },
    getTimeHours() {
      let _date = new Date().getHours();
      let _data = [];
      for (let i = 0; i < 7; i++) {
        let j = 0;
        j = _date + i * 3;
        let m;
        if (j > 24) {
          m = j % 24; 
          if (m < 10) {
            m = "0" + m + ":00";
          } else {
            m = m + ":00";
          }
        } else {
          m = j + ":00";
        }
        _data.push(m);
      }
      _data[0] = "现在"; 
      this.lineAndBarOption.xAxis[0].data  =this.lineAndBarOption.xAxis[1].data = _data;
    },
    getFutureWeather(){ 
      this.lineAndBarOption.series[0].data = this.lineFuture.FutureTemp;
      this.lineAndBarOption.series[1].data = this.lineFuture.FutureWind;
      let num = (arg) => Math.min(...arg);
      this.lineAndBarOption.yAxis[0].min = num(this.lineFuture.FutureTemp);
      this.bacImage = this.lineFuture.weatherIcon ? `bg${this.lineFuture.weatherIcon}`: ''
      this.bacImage5 = this.lineFuture.weatherIcon ? `bg${this.lineFuture.weatherIcon5}`: ''
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeTheChart);
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/iconbg.css";

.project-weather {
  width: 100%;
}
.weather-title {
  margin: 19px 0 10px 21px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi;
  font-weight: 400;
  color: #0b79f0;
  line-height: 6px;
}
.echart-line-bar {
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  .weather-icon{
    position: absolute;
    width: 40px;
    height: 30px;
    top: 18px;
    left: 20%; 
  }
  .weather-cloudy{ 
    left: 60%; 
  }
}
.echart-line {
  width: 100%; 
}

.echart-bar {
  width: 100%;
  margin-bottom: 20px;
  padding-bottom: 15px;
}
</style>